<div [attr.title]="question.prevPanelText" (click)="prevPanelClick()" [class]="question.getPrevButtonCss()">
  <svg [iconName]="question.cssClasses.progressBtnIcon" [size]="'auto'" sv-ng-svg-icon></svg>
</div>
